// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SizeTile-tile-86ae{flex-shrink:0;height:100%;border-radius:16px;padding:16px;background-color:var(--ui-background-color)}`, "",{"version":3,"sources":["webpack://./src/page/BasicInferenceScreen/SizeTile.module.scss"],"names":[],"mappings":"AAAA,oBACE,aAAA,CACA,WAAA,CACA,kBAAA,CACA,YAAA,CACA,2CAAA","sourcesContent":[".tile {\n  flex-shrink: 0;\n  height: 100%;\n  border-radius: 16px;\n  padding: 16px;\n  background-color: var(--ui-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `SizeTile-tile-86ae`
};
module.exports = ___CSS_LOADER_EXPORT___;
